export default __webpack_public_path__ + "public/assets/images/fd7d6088746d65d5ffbb6132509c5643.png";